import hamburger from './HamburgerMenu.svg'
import rose from './AllDeserveHome.jpg'
import React from 'react';

const styles = {
  aboutContainer: {
    alignItems: 'stretch',
    flex: 1,
    backgroundColor: 'white',
    marginLeft: '25%',
    marginRight: '25%'
  },
  aboutView: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    margin: 20
  },
  menuIcon: {
    width: '80px',
    height: '80px',
    position: 'absolute',
    top: 0,
    right: 0,
    margin: 20
  },
  roseImage: {
    height: '300px',
    width: '300px',
    marginTop: '100px',
  },
  headline: {
    textShadow: '3px 3px 3px #ccc'
  }
}

function About(props) {
  return (
    <div style={styles.aboutContainer}>
      <div style={styles.aboutView}>
        <a href='/menu'>
          <img src={hamburger} style={styles.menuIcon} />
        </a>
        <img src={rose} style={styles.roseImage} />
        <h1 style={styles.headline}>
          About
        </h1>
        <p>
          Housing is a human right, and an unwillingness to recognize that right at a
          governmental level is driving a homelessness epidemic. Since 2021, rent prices
          have risen a whopping 15.5%, with the average Pittsburgher spending $2,000 every month on rent.
          It’s safe to say that the vast majority of Western Pennsylvanians did not see their wages rise to
          accommodate this inflation. Landlords are taking advantage of the working class, pricing them out
          onto the streets, and government officials are standing idly by.
        </p>
        <p>
          We at Pittsburgh DSA are working to change things by collectively organizing the working class
          and seeing that our demands are met. Since one of our core tenets is that housing is a right which
          every person deserves, we are using our tent campaign to bring attention to the lackluster response by
          officials in addressing homelessness in Allegheny County.
        </p>
        <h2>
          Pittsburgh is often lauded as America’s
          <a style={{ marginLeft: 5, marginRight: 5}} href="https://www.visitpittsburgh.com/media/news-releases/pittsburgh-named-most-livable-city-in-continental-united-states/">
            “most livable city.”
          </a>
          But we ask, “most livable for who?”
        </h2>
        <p>
          The amount of unhoused Pittsburghers has spiked by 21% since last year as more and more poor and working c
          lass citizens get priced out of the market or evicted from their current residences. At any given time,
          there are 800 Allegheny county residents sleeping without a roof over their heads, and that number doesn’t
          decrease just because the temperatures are dropping.
        </p>
        <p>
          Voting is the minimum effort we must put forth to create change. In order to remediate this epidemic of
          unhoused Pennsylvanians, we must first cast ballots in favor of politicians with platforms that call
          for housing justice. These midterm elections coming up on November 8 are a crucial starting point for a
          campaign toward equity. However, we must also collectively hold these politicians accountable, meaning the
          work is not finished at the ballot box.
        </p>
        <p>
          Our DSA chapter is fighting to ensure that the people are treated humanely, and we want to see our neighbors
          put into satisfactory housing and kept there. We are fighting to secure the right to legal counsel for renters
          facing eviction from landlords, and we are working to elect officials who are doing the real fighting for the working class.
        </p>
        <p>
          On this website, you can find more details about the Pittsburgh DSA’s Right to Counsel initiative, which will
          help to keep renters in their housing and off the street simply because they lack the resources to fight back against a
          landlord. You will also find voter resources to ensure you’re ready to cast a ballot on election day.
          Our postcard art gallery shows off your neighbors’ stories of housing insecurity, and a form where you can tell us
          about your own personal battles with housing instability.
        </p>
        <p>
          Officials’ response to these jarring statistics is, as it stands today, completely unacceptable. At the City Council
          level, calls to <a href="https://www.wpxi.com/news/local/pittsburgh-city-council-working-remove-homeless-encampments/CT4L2AQDMREXFFV4725L6EBV54/">break up homeless encampments</a>
          with police have been condemned as inhumane. Plans to <a href="https://www.wesa.fm/politics-government/2022-08-24/pittsburgh-city-council-considers-measures-to-address-spike-in-homelessness">set aside city-
          owned land</a> for various types of temporary shelter and short-term solutions will take years to come to fruition –
          meanwhile, 7.5% of all rental properties in the city <a href="https://www.huduser.gov/portal/publications/pdf/PittsburgPA-CHMA-20.pdf">remain vacant</a>. There isn’t time to act slowly, especially
          when there is a solution right in front of us.
        </p>
        <p>
          We invite like-minded Pittsburghers to join our chapter as well, so that we may grow our collective power and
          ensure that our goals are met. You can find a link <a href="https://pghdsa.org">here</a> to see more information about our organization and steps to join.
        </p>
        <br />
        <p>
          This campaign is supported by the <a href="https://c4aa.org/">Center for Artistic Activism.</a>
        </p>
      </div>
    </div>
  )
}

export default About;
